import React from 'react'

import Label from '~/truck/label'

import { Container } from './elements'

const Header = props => {
  const { title, subTitle } = props

  return (
    <Container>
      <Label as="p" $textStyle="h4Semibold">
        {title}
      </Label>
      <Label as="p">{subTitle}</Label>
    </Container>
  )
}

export default Header
